import type { LandingVariant } from '../types/landing'

export const landingVariants: LandingVariant[] = [
  {
    slug: 'bay-area',
    pageTitle: 'Twenty Mile House — Bay Area',
    eyebrow: 'Bay Area Brides',
    headline: [
      { text: 'Trade one day for a whole wedding weekend on 200 private acres.' },
    ],
    intro:
      'Just under four hours from the city, outside Lake Tahoe. Your guests stay on site, and your coordinator handles every detail, all on one invoice.',
    stats: [
      { value: 'Up to 250', label: 'Guests seated' },
      { value: '54', label: 'Guests sleep on site' },
      { value: '4 hr', label: 'Drive from the Bay' },
      { value: '3 days', label: 'On the property' },
      { value: 'All-inclusive', label: 'Vendors handled' },
    ],
  },
  {
    slug: 'northern-california',
    pageTitle: 'Twenty Mile House — Sacramento & Northern California',
    eyebrow: 'For Sacramento, Roseville, Folsom, Chico and Reno couples',
    headline: [
      { text: 'A mountain wedding weekend just a short drive from home, with every detail done for you.' },
    ],
    intro:
      '200 private acres in the Sierra, on-site lodging for your closest guests, and all-inclusive packages with trusted local vendors, your own coordinator and one invoice.',
    stats: [
      { value: 'Up to 250', label: 'Guests seated' },
      { value: '54', label: 'Guests sleep on site' },
      { value: '1 hr', label: 'From Reno' },
      { value: '2.5 hrs', label: 'From Sacramento' },
      { value: 'All-inclusive', label: 'Vendors handled' },
    ],
  },
  {
    slug: 'out-of-state',
    pageTitle: 'Twenty Mile House — Destination Weddings',
    eyebrow: 'For couples planning a Northern California wedding',
    headline: [
      { text: 'We give you full access to our 200-acre property for your destination wedding weekend.' },
    ],
    intro:
      'Every detail handled. With 200 private acres, on-site accommodations and all-inclusive packages, we bring in trusted local vendors, your own coordinator and one invoice — so your day is everything you imagined and more.',
    stats: [
      { value: 'Up to 250', label: 'Guests seated' },
      { value: '54', label: 'Guests sleep on site' },
      { value: '1 hr', label: 'From Reno-Tahoe airport' },
      { value: '72 hrs', label: 'One place' },
      { value: 'All-inclusive', label: 'Vendors handled' },
    ],
  },
]
